// extracted by mini-css-extract-plugin
export default {"content":"DocumentsPage_content__8VgSm"};